import { render, staticRenderFns } from "./FieldTextarea.vue?vue&type=template&id=24adbffe"
import script from "./FieldTextarea.vue?vue&type=script&lang=ts"
export * from "./FieldTextarea.vue?vue&type=script&lang=ts"
import style0 from "./FieldTextarea.vue?vue&type=style&index=0&id=24adbffe&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FieldWrapper: require('/builds/project/wyffest/frontend/components/field/FieldWrapper.vue').default})
